import React, { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { useHistory } from 'react-router-dom';

// Assets
import Arrow from '../../assets/svg/arrowDown.jsx';
import Icon1 from '../../assets/svg/headerIcon1.jsx';
import Icon2 from '../../assets/svg/headerIcon2.jsx';
import Icon3 from '../../assets/svg/headerIcon3.jsx';
import Users from '../../assets/svg/userHeader.jsx';

// i18n
import i18n from '../../i18n/es.json';

// Services
import { completeLogoutService } from '../../services/Auth';
import { useClickOutside } from '../../utils/customHooks';

// Styles
import classes from './UserMenu.module.css';

const UserMenu = ({ userLogged }) => {
  const [show, setShow] = useState(false);
  const history = useHistory();
  const menuContainerRef = useRef();

  // ------------------------------------------- //
  // -------------- Action Handlers ------------ //
  // ------------------------------------------- //

  const logoutHandler = async () => {
    completeLogoutService();
  };

  const personalInfoHandler = () => {
    history.push('/editarInformacionPersonal');
    setShow(false);
  };

  const changePasswordHandler = () => {
    history.push('/changePassword');
    setShow(false);
  };

  useClickOutside(menuContainerRef, () => setShow(false));

  // ------------------------------------------- //
  // ----------------- Return ------------------ //
  // ------------------------------------------- //

  return (
    <>
      <div className={classes.btnUserContainer} onClick={() => setShow(true)}>
        <Button variant="light">
          <Users />
        </Button>
        <div className={classes.userContainer}>
          <p className={classes.userName}>{userLogged.username}</p>
          <p className={classes.userRole}>{userLogged.profileName}</p>
        </div>
        <div className={classes.arrow}>
          <Arrow />
        </div>
      </div>
      {show && (
        <div ref={menuContainerRef} className={classes.wrapper}>
          <div className={classes.optContainer}>
            <ul className={classes.listOptions}>
              <li onClick={personalInfoHandler}>
                <Icon1 />
                {i18n.authOptions.editPersonalInfo}
              </li>
              <li onClick={changePasswordHandler}>
                <Icon2 />
                {i18n.authOptions.changePassword}
              </li>
              <li onClick={logoutHandler}>
                <Icon3 />
                {i18n.authOptions.logOut}
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default UserMenu;
